import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRouter } from 'vue-router'

import { storeToRefs } from 'pinia'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'

import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import PATHS from '@/router/paths'

import CreatePolicyModal from '@/modules/company/Policy/components/CreatePolicyModal.vue'
import type { CreatePolicyFormData } from '@/modules/company/Policy/components/CreatePolicyModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modalActive: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }) {

const router = useRouter()
const toast = useToast()
const { notifyError } = useErrorToast()
const dsPolicyStore = useDsPolicyStore()

const { isLoading } = storeToRefs(dsPolicyStore)





const createPolicy = async (formData: CreatePolicyFormData) => {
  try {
    const createdDsPolicy = await dsPolicyStore.createDsPolicy({
      name: formData.name,
      companyOwnerId: Number(formData.companyId)
    })

    if (createdDsPolicy?.id) {
      await dsPolicyStore.fetchDsPolicyById(createdDsPolicy.id)
      router.push(`${PATHS.MANAGE_DOCTOR_AUTHORIZATION_POLICIES}/${createdDsPolicy.id}`)
      toast.success('Política criada com sucesso!')
    }
  } catch (error) {
    console.error(error)
    notifyError(error, 'Não foi possível criar a política de restrição.')
  } finally {
    emits('close')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CreatePolicyModal, {
    "modal-active": _ctx.modalActive,
    loading: _unref(isLoading),
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('close'))),
    onSubmit: createPolicy
  }, null, 8, ["modal-active", "loading"]))
}
}

})